import { service, factories } from 'powerbi-client';
const powerbi = new service.Service(factories.hpmFactory, factories.wpmpFactory, factories.routerFactory);
/**
 * Embed a PowerBI object in the specified element.
 */
export const embed = (container, config) => new Promise((resolve, reject) => {
    const item = powerbi.embed(container, config);
    item.on('loaded', () => resolve(item));
    item.on('error', e => reject(e.detail));
});
